import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20flowing%20gradient%20background%20with%20warm%20coral%20orange%20and%20soft%20teal%20waves%2C%20minimalist%20geometric%20shapes%20with%20subtle%20glass%20texture%2C%20clean%20sophisticated%20design%2C%20editorial%20quality%2C%20soft%20ethereal%20atmosphere&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="最新发布页背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>
      <div className="relative z-10 w-full text-center px-4 md:px-6 py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight tracking-tight">
          最新发布页
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚平台全部最新内容，实时更新、分类清晰，让您第一时间获取最新资讯、产品、公告与活动信息，告别信息滞后，随时掌握最新动态。
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/category/latest-news"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览最新内容
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12 flex-wrap">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">50万+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">月活跃用户</div>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">12万+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">累计发布内容</div>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">99.9%</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">服务可用率</div>
          </div>
        </div>
      </div>
    </section>
  );
}